module.exports = __webpack_public_path__ + "static/logo-e25d2284fb87a18c49b69720338febc7.png";